var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V6C6 4.73684 6.73684 4 8 4H16C17.2632 4 18 4.73684 18 6V21C18 21.5439 18.4561 22 19 22C19.5439 22 20 21.5439 20 21V6C20 3.75439 18.2456 2 16 2H8C5.75439 2 4 3.75439 4 6V21C4 21.5439 4.45614 22 5 22C5.54386 22 6 21.5439 6 21ZM19.4912 20.1404L12 15.8421L4.50877 20.1404C4.21053 20.2982 4 20.6316 4 21C4 21.5439 4.45614 22 5 22C5.17544 22 5.35088 21.9474 5.49123 21.8596L12 18.1579L18.5088 21.8596C18.6491 21.9474 18.8246 22 19 22C19.5439 22 20 21.5439 20 21C20 20.6316 19.7895 20.2982 19.4912 20.1404Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutlined);
export default __webpack_public_path__ + "static/media/bookmark_outlined.b5d8a67c.svg";
export { ForwardRef as ReactComponent };